import React, { Component } from "react";
import { API_URL } from "src/scenes/App";
import axios from "axios";
import styled from "styled-components";
import {
    LottieLoadingIndicator, ErrorText, FlexContainer,
    BankCountry, AccountHolderName, BankName, AccountNumber, SwiftCode, BsbOrIban,
    InvoiceOrStatementEmail, StreetAddress, StreetAddress2nd, Toast,
    City, State, AddressCountry, PostcodeOrZip, ErrorList, ContainerGrid,
    PortalCaption,
    PortalPanelHeader,
    PortalSectionTitle,
    PortalFormActions,
    PortalFormBody,
    PortalFormSection,
    PortalFormSectionDescription,
    PortalFormSectionHeader,
    PortalFormSectionTitle,
    PortalFormSurface,
    StandardModalActionButton,
    StandardModalActionGroup,
    portalColors
} from "src/components";

import { AUSTRALIA } from "src/constants/subscriptions";

const FormShell = styled.div`
    width: 100%;
    display: grid;
    gap: 1rem;
`;

const ErrorPanel = styled.div`
    padding: 0.85rem 1rem;
    border: 1px solid var(--calendar-danger, #D64545);
    border-radius: 12px;
    background: var(--calendar-danger-soft, rgba(214, 69, 69, 0.1));
`;

const DetailsNote = styled(PortalFormSectionDescription)`
    padding: 0.85rem 1rem;
    border: 1px solid ${portalColors.border};
    border-radius: 8px;
    background: ${portalColors.surfaceSoft};
`;

class ClientLicenseBankDetailsForm extends Component {
    state = {
        bankAccountDetails: {
            country: "",
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            swiftCode: "",
            bsbOrIban: "",
            invoiceOrStatementEmail: "",
            streetAddress: "",
            streetAddress2: "",
            city: "",
            state: "",
            addressCountry: "",
            postcodeOrZip: "",
        },
        message: "",
        inputErrors: [],
        loadingSubmit: false,
        isLoading: false,
        isSwiftCodeDisabled: null,
        fetching: 0,
    };

    componentDidMount() {
        this.setState({
            bankAccountDetails: this.props.bankAccountDetails,
            isSwiftCodeDisabled: this.props.bankAccountDetails.country === AUSTRALIA,
        });
    }

    getErrors() {
        let bankAccountDetails = this.state.bankAccountDetails;
        let errors = [];

        if (bankAccountDetails.country === "" || bankAccountDetails.country === null) {
            errors.push(ErrorList.EMPTY_COUNTRY);
        }

        if (bankAccountDetails.accountHolderName === "" || bankAccountDetails.accountHolderName === null) {
            errors.push(ErrorList.EMPTY_ACCOUNT_HOLDER_NAME);
        }

        if (bankAccountDetails.bankName === "" || bankAccountDetails.bankName === null) {
            errors.push(ErrorList.EMPTY_BANK_NAME);
        }

        if (bankAccountDetails.accountNumber === "" || bankAccountDetails.accountNumber === null) {
            errors.push(ErrorList.EMPTY_ACCOUNT_NUMBER);
        } else if (bankAccountDetails.country === AUSTRALIA && !(bankAccountDetails.accountNumber.length >= 4 && bankAccountDetails.accountNumber.length <= 12)) {
            errors.push(ErrorList.AUS_INVALID_ACCOUNT_NUMBER);
        }

        if (bankAccountDetails.country !== AUSTRALIA) {
            if (bankAccountDetails.swiftCode === "" || bankAccountDetails.swiftCode === null) {
                errors.push(ErrorList.EMPTY_SWIFT_CODE);
            }
        }

        if (bankAccountDetails.bsbOrIban === "" || bankAccountDetails.bsbOrIban === null) {
            errors.push(ErrorList.EMPTY_BSB_OR_IBAN);
        } else if (bankAccountDetails.country === AUSTRALIA && bankAccountDetails.bsbOrIban.length !== 6) {
            errors.push(ErrorList.AUS_BSB_LENGTH);
        }

        if (bankAccountDetails.invoiceOrStatementEmail === "" || bankAccountDetails.invoiceOrStatementEmail === null) {
            errors.push(ErrorList.EMPTY_INVOICE_OR_STATEMENT_EMAIL);
        }
        else {
            /* regex to validate email */
            if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(bankAccountDetails.invoiceOrStatementEmail) === false) {
                errors.push(ErrorList.EMAIL_INVALID);
            }
        }

        /** ADDRESS */
        if (bankAccountDetails.streetAddress === "" || bankAccountDetails.streetAddress === null) {
            errors.push(ErrorList.EMPTY_STREET_ADDRESS);
        }

        if (bankAccountDetails.city === "" || bankAccountDetails.city === null) {
            errors.push(ErrorList.EMPTY_CITY);
        }

        if (bankAccountDetails.state === "" || bankAccountDetails.state === null) {
            errors.push(ErrorList.EMPTY_STATE);
        }

        if (bankAccountDetails.addressCountry === "" || bankAccountDetails.addressCountry === null) {
            errors.push(ErrorList.EMPTY_ADDRESS_COUNTRY);
        }

        if (bankAccountDetails.postcodeOrZip === "" || bankAccountDetails.postcodeOrZip === null) {
            errors.push(ErrorList.EMPTY_POST_CODE_OR_ZIP);
        }

        return errors;
    }

    submitEarningBankAccountDetailsForm = () => {
        this.setState({
            loadingSubmit: true,
            inputErrors: [],
            responseErrors: "",
        });

        const bankAccountDetailsData = this.state.bankAccountDetails;

        let errors = this.getErrors();

        if (errors.length > 0) {
            this.setState({
                loadingSubmit: false,
                inputErrors: errors,
                responseErrors: "Please check the fields again for any errors. The form cannot be submitted until all fields are valid.",
            });
        }
        else {
            this.postClient(bankAccountDetailsData);
        }
    };

    postClient = (bankAccountDetailsData) => {
        const { setIsShowGetStarted } = this.props;

        axios.post(`${API_URL}/company/upsertBankAccountDetails`, {
            countryCode: bankAccountDetailsData.country,
            accountHolderName: bankAccountDetailsData.accountHolderName,
            bankName: bankAccountDetailsData.bankName,
            accountNumber: bankAccountDetailsData.accountNumber,
            swiftCode: bankAccountDetailsData.swiftCode,
            bsbOrIban: bankAccountDetailsData.bsbOrIban,
            email: bankAccountDetailsData.invoiceOrStatementEmail,

            street: bankAccountDetailsData.streetAddress,
            street2: bankAccountDetailsData.streetAddress2,
            city: bankAccountDetailsData.city,
            state: bankAccountDetailsData.state,
            countryCodeAddress: bankAccountDetailsData.addressCountry,
            postcodeOrZip: bankAccountDetailsData.postcodeOrZip,
        },
        {
            headers: {
                Authorization: "Bearer " + this.props.token
            }
        }).then(res => {
            Toast.info("Your bank account details have been updated.");
            setIsShowGetStarted(false);
        }).catch(error => {
            this.setState({
                responseErrors: error.getApiErrorDetails().message,
                loadingSubmit: false,
            });
        });
    };

    cancel = () => {
        this.props.setIsShowGetStarted(false);
    };

    inputBankAccountDetailsValue = (event, propertyName) => {
        const propertyNameValue = event.target.value;

        this.setState(prevState => ({
            bankAccountDetails: { // object that we want to update
                ...prevState.bankAccountDetails, // keep all other key-value pairs
                [propertyName]: propertyNameValue // update the value of specific key
            }
        }));

        //Disable Swift Code Field when Bank Account Info.Country is AU
        if (propertyName === "country") {
            this.setState(prevState => ({
                bankAccountDetails: {
                    ...prevState.bankAccountDetails,
                    "swiftCode": propertyNameValue === AUSTRALIA ? "" : prevState.bankAccountDetails.swiftCode
                },
                isSwiftCodeDisabled: propertyNameValue === AUSTRALIA
            }));
        }
    };

    render() {
        const { inputErrors, responseErrors, bankAccountDetails, loadingSubmit, isLoading, isSwiftCodeDisabled } = this.state;

        if (isLoading) {
            return (
                <FlexContainer height="60vh" flexGrow="1" alignItems="center" justifyContent="center">
                    <LottieLoadingIndicator />
                </FlexContainer>
            );
        }
        else {
            return (
                <FormShell>
                    <PortalPanelHeader withDivider>
                        <div>
                            <PortalSectionTitle size="1.35rem">
                                Getting Started: Earnings Bank Account Details
                            </PortalSectionTitle>
                            <PortalCaption maxWidth="42rem">
                            Please kindly provide the bank account information and invoice statement details below,
                            to enable us to deposit your earnings to the designated account and email you statements.
                            </PortalCaption>
                        </div>
                    </PortalPanelHeader>

                    <PortalFormSurface as="form" marginTop="0" onSubmit={(e) => {e.preventDefault(); }} >
                        {
                            responseErrors && (
                                <ErrorPanel>
                                    <ErrorText margin="0" errorMargin="0" height="auto">
                                        { responseErrors}
                                    </ErrorText>
                                </ErrorPanel>
                            )
                        }

                        <PortalFormBody columns="minmax(0, 1fr)" gap="1rem" padding="1rem">
                            <PortalFormSection>
                                <PortalFormSectionHeader withDivider>
                                    <PortalFormSectionTitle>Bank account information</PortalFormSectionTitle>
                                    <PortalFormSectionDescription>
                                        Add the account your earnings should be paid into.
                                    </PortalFormSectionDescription>
                                </PortalFormSectionHeader>
                                <ContainerGrid>
                                    <BankCountry bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <AccountHolderName bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <BankName bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <AccountNumber bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <SwiftCode bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} isSwiftCodeDisabled={isSwiftCodeDisabled} placeholderDisabled={true}/>
                                    <BsbOrIban bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                </ContainerGrid>
                                <InvoiceOrStatementEmail bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                            </PortalFormSection>

                            <PortalFormSection>
                                <PortalFormSectionHeader withDivider>
                                    <PortalFormSectionTitle>Statement address</PortalFormSectionTitle>
                                    <PortalFormSectionDescription>
                                        Provide the business address associated with this payout account.
                                    </PortalFormSectionDescription>
                                </PortalFormSectionHeader>
                                <ContainerGrid>
                                    <StreetAddress bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <StreetAddress2nd bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <City bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <State bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                    <AddressCountry bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true}/>
                                    <PostcodeOrZip bankAccountDetails={bankAccountDetails} inputBankAccountDetailsValue={this.inputBankAccountDetailsValue} inputErrors={inputErrors} placeholderDisabled={true} />
                                </ContainerGrid>

                                <DetailsNote>
                                    You can update your bank account details at any time in Account Settings &gt; Renewals & Earnings.
                                </DetailsNote>
                            </PortalFormSection>
                        </PortalFormBody>

                        <PortalFormActions sticky={false} padding="1rem">
                            <StandardModalActionGroup $pushRight>
                                <StandardModalActionButton
                                    type="button"
                                    onClick={this.cancel}
                                    disabled={loadingSubmit}
                                >
                                    Cancel
                                </StandardModalActionButton>
                                <StandardModalActionButton
                                    type="button"
                                    $variant="primary"
                                    onClick={this.submitEarningBankAccountDetailsForm}
                                    disabled={loadingSubmit}
                                >
                                    {loadingSubmit
                                        ? <LottieLoadingIndicator height="1.5rem" width="1.5rem" containerHeight="1.5rem" margin="0" />
                                        : "Save"}
                                </StandardModalActionButton>
                            </StandardModalActionGroup>
                        </PortalFormActions>
                    </PortalFormSurface>
                </FormShell>
            );
        }
    }
}

export default ClientLicenseBankDetailsForm;
